import { GuestWishlist, AccountWishlist, PREFIX } from './wishlist-store.js?v=20261022-auto-connect-1';
import { CustomerAccountMetafieldAdapter } from './wishlist-account.js?v=20261022-auto-connect-1';
import { WishlistAuth, randomSecret } from './wishlist-auth.js?v=20261022-auto-connect-1';
import { wishlistConfig } from './wishlist-config.js?v=20261022-auto-connect-1';
import { WishlistRedirect } from './wishlist-redirect.js?v=20261022-auto-connect-1';
const context = document.querySelector('[data-wishlist-context]');
if (context) {
  let account = context.dataset.account === 'true';
  let connected = false, busy = false, connecting = false, starting = true, suspended = false;
  let accountStore = null, sessionVersion = 0, checking = false, initialized = false, leaving = false;
  let connectionError = '', needsLogin = false, observedOwner;
  const root = context.dataset.root || '/';
  let store, handles = [], revision = 0;
  const gallery = document.querySelector('[data-wishlist-gallery]');
  const grid = gallery?.querySelector('[data-wishlist-grid]');
  const status = gallery?.querySelector('[data-wishlist-status]');
  const retry = gallery?.querySelector('[data-wishlist-retry]');
  const connect = gallery?.querySelector('[data-wishlist-connect]');
  const logout = gallery?.querySelector('[data-wishlist-logout]');
  const login = gallery?.querySelector('[data-wishlist-login]');
  const configured = Boolean(wishlistConfig.clientId) && location.origin === wishlistConfig.shopOrigin;
  const signalKey = 'deinfriseur:wishlist:session-signal';
  const channel = typeof BroadcastChannel === 'function' ? new BroadcastChannel(signalKey) : null;
  const signal = () => { channel?.postMessage('invalidate'); try { localStorage.setItem(signalKey, randomSecret()); } catch {} };
  const pageController = new AbortController();
  const redirectStore = () => new WishlistRedirect(sessionStorage, wishlistConfig);
  const clearRedirect = () => { try { redirectStore().clear(); } catch {} };
  const probe = async () => {
    const response = await fetch(`${wishlistConfig.shopOrigin}/?view=wishlist-session&_=${randomSecret()}`, {cache:'no-store',credentials:'same-origin',redirect:'error',signal:AbortSignal.any([pageController.signal, AbortSignal.timeout(10000)])});
    if (!response.ok) throw new Error('Deine Shop-Sitzung konnte nicht geprüft werden.');
    const data = JSON.parse(await response.text());
    if (data.customerId !== null && (typeof data.customerId !== 'string' || !/^gid:\/\/shopify\/Customer\/\d+$/.test(data.customerId))) throw new Error('Ungültige Shop-Sitzung.');
    if (observedOwner !== undefined && observedOwner !== data.customerId) signal();
    observedOwner = data.customerId;
    return observedOwner;
  };
  const visibleHandles = () => account && (suspended || document.hidden || !connected) ? [] : handles;
  const invalidate = () => {
    sessionVersion++; revision++; connected = false; busy = false;
    accountStore?.clear(); accountStore = null; handles = []; grid?.replaceChildren();
    grid?.setAttribute('aria-busy', 'false'); reflect();
  };
  const auth = new WishlistAuth(wishlistConfig, {probe,onInvalidate:invalidate});
  const announcer = document.createElement('p');
  announcer.className = 'visually-hidden'; announcer.setAttribute('role', 'status'); document.body.append(announcer);
  function error(message, requireLogin = false) {
    connectionError = message; needsLogin = requireLogin;
    if (!gallery) announcer.className = 'wishlist-toast';
    announcer.textContent = message;
    if (status) status.textContent = message;
    if (retry) retry.hidden = requireLogin || !configured;
    reflect();
  }
  function reflect() {
    const visible = visibleHandles();
    if (connect) { connect.hidden = account || connected || starting; connect.disabled = !configured || busy || connecting; }
    if (logout) logout.hidden = !connected;
    if (login) login.hidden = !needsLogin;
    if (gallery) {
      gallery.querySelector('.wishlist__notice strong').textContent = connected ? 'In deinem Kundenkonto gespeichert' : account ? 'Kontomerkliste' : 'In diesem Browser gespeichert';
      gallery.querySelector('.wishlist__notice p').textContent = connected ? 'Auf deinen Geräten verfügbar.' : account ? (connectionError || 'Deine Kontomerkliste wird geladen …') : configured ? 'Deine Favoriten bleiben in diesem Browser gespeichert. Melde dich an, um deine Kontomerkliste zu laden.' : 'Die geräteübergreifende Kontosynchronisierung ist noch nicht eingerichtet.';
    }
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const saved = visible.includes(button.dataset.wishlistToggle);
      button.disabled = starting || busy || connecting || suspended || checking || (account ? !configured : !store);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${button.dataset.productTitle || 'Produkt'} ${saved ? 'aus Merkliste entfernen' : 'merken'}`);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(el => { el.textContent = String(visible.length); el.hidden = !visible.length; });
    document.querySelectorAll('[data-wishlist-header]').forEach(el => el.setAttribute('aria-label', `Merkliste: ${visible.length} Produkte`));
  }
  const node = (tag, cls, text) => { const el = document.createElement(tag); el.className = cls; if (text) el.textContent = text; return el; };
  function card(handle, product, failed) {
    const article = node('article', 'wishlist__card');
    const image = node('img', 'wishlist__image');
    if (product?.featured_image) {
      const source = new URL(product.featured_image, location.origin);
      if (source.protocol === 'https:' || source.origin === location.origin) { image.src = source.href; image.alt = product.title; image.loading = 'lazy'; article.append(image); }
    }
    const heart = node('button', 'wishlist-heart'); heart.type = 'button'; heart.dataset.wishlistToggle = handle; heart.dataset.productTitle = product?.title || handle;
    const icon = document.querySelector('[data-wishlist-header] svg'); if (icon) heart.append(icon.cloneNode(true));
    article.append(heart, node('p', 'wishlist__vendor', product?.vendor || 'Gespeichertes Produkt'), node('h2', 'wishlist__title', product?.title || 'Produkt derzeit nicht verfügbar'));
    const link = node('a', 'wishlist__product-link', failed ? 'Produkt prüfen' : 'Zum Produkt'); link.href = `${root}products/${encodeURIComponent(handle)}`; article.append(link);
    const remove = node('button', 'wishlist__remove', 'Entfernen'); remove.type = 'button'; remove.dataset.wishlistToggle = handle; remove.dataset.productTitle = product?.title || handle; article.append(remove);
    return article;
  }
  async function render(focusIndex) {
    reflect(); if (!grid) return;
    const current = ++revision;
    retry.hidden = true;
    if (account && (starting || connecting || suspended || document.hidden)) {
      grid.replaceChildren(); grid.setAttribute('aria-busy', String(starting || connecting));
      status.textContent = 'Deine Kontomerkliste wird geladen …'; return;
    }
    if (account && !connected) {
      grid.replaceChildren(); grid.setAttribute('aria-busy', 'false');
      status.textContent = connectionError || 'Deine Kontomerkliste konnte nicht geladen werden. Bitte erneut versuchen.';
      retry.hidden = needsLogin || !configured; return;
    }
    if (!account && !store) { grid.setAttribute('aria-busy', 'false'); error('Dein Browserspeicher ist nicht verfügbar. Bitte prüfe deine Browsereinstellungen.'); return; }
    grid.setAttribute('aria-busy', 'true');
    status.textContent = handles.length ? 'Merkliste wird geladen …' : 'Deine Merkliste ist noch leer. Merke Produkte mit dem Herz.';
    const snapshot = [...handles];
    let failed = false;
    const cards = await Promise.all(snapshot.map(async handle => {
      try {
        const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { signal: AbortSignal.timeout(10000), credentials: 'same-origin' });
        if (!response.ok) throw new Error('Produkt nicht verfügbar');
        const product = await response.json(); return card(handle, product, false);
      } catch { failed = true; return card(handle, null, true); }
    }));
    if (current !== revision || (account && (suspended || document.hidden))) return;
    grid.replaceChildren(...cards); grid.setAttribute('aria-busy', 'false'); reflect();
    if (snapshot.length) status.textContent = failed ? 'Einige Produkte konnten nicht geladen werden. Deine Merkliste bleibt gespeichert.' : `${snapshot.length} ${snapshot.length === 1 ? 'Produkt' : 'Produkte'} gemerkt`;
    retry.hidden = !failed;
    if (focusIndex !== undefined) (grid.children[Math.min(focusIndex, cards.length - 1)]?.querySelector('.wishlist__remove') || gallery.querySelector('h1')).focus();
  }
  function connectionFailed(cause) {
    auth.clear(); connecting = false; busy = false; starting = false; suspended = false;
    const message = ['SecurityError', 'QuotaExceededError'].includes(cause.name) ? 'Dein Browserspeicher ist nicht verfügbar. Bitte prüfe deine Browsereinstellungen und versuche es erneut.' : cause.message;
    error(message || 'Deine Kontomerkliste konnte nicht geladen werden. Bitte erneut versuchen.', cause.code === 'login_required' || cause.code === 'session_expired');
  }
  async function refresh() {
    if (busy || connecting || checking || starting) return;
    if (account && !connected) return startConnection();
    const version = sessionVersion;
    try {
      connectionError = ''; needsLogin = false;
      if (account) {
        const items = await accountStore.load();
        if (version !== sessionVersion) return;
        handles = items;
      } else { store ||= new GuestWishlist(localStorage); handles = store.list(); }
      await render();
    } catch (cause) {
      if (account) {
        if (cause.code === 'reauthorization_required') return startConnection();
        connectionFailed(cause);
      } else error('Dein Browserspeicher ist nicht verfügbar. Bitte prüfe deine Browsereinstellungen.');
    }
  }
  async function startConnection(pendingHandle = null, {silent = true, pendingSaved = true} = {}) {
    if (!configured || busy || connecting || starting) return;
    connecting = true; busy = true; account = true; connectionError = ''; needsLogin = false;
    handles = []; grid?.replaceChildren(); reflect();
    if (status) status.textContent = 'Deine Kontomerkliste wird geladen …';
    try {
      const version = sessionVersion;
      const owner = await probe();
      if (version !== sessionVersion) return;
      if (silent && !owner) throw Object.assign(new Error('Deine Shop-Sitzung ist abgelaufen. Bitte melde dich im Kundenkonto an.'), {code:'login_required'});
      const url = await auth.begin({silent});
      connecting = true; busy = true; reflect();
      redirectStore().save(auth.transaction, {
        owner, returnTo: location.pathname + location.search + location.hash,
        pendingHandle, pendingSaved, scrollY: Math.max(0, window.scrollY),
      });
      leaving = true;
      location.replace(url);
    } catch (cause) { clearRedirect(); connectionFailed(cause); }
  }
  async function finishConnection(record) {
    if (record.response.error) {
      const requireLogin = ['login_required', 'interaction_required', 'consent_required'].includes(record.response.error);
      throw Object.assign(new Error(requireLogin ? 'Deine Anmeldung muss erneuert werden. Bitte melde dich im Kundenkonto an.' : 'Die Anmeldung wurde nicht abgeschlossen. Bitte erneut versuchen.'), {code:requireLogin ? 'login_required' : 'authorization_failed'});
    }
    await auth.resume(record);
    const version = sessionVersion;
    await auth.accept(record.response, record.owner);
    if (version !== sessionVersion) return;
    const adapter = new CustomerAccountMetafieldAdapter((query, variables) => auth.request(query, variables));
    const nextStore = new AccountWishlist(adapter);
    accountStore = nextStore;
    let items = await nextStore.load();
    if (version !== sessionVersion) return;
    if (record.pendingHandle && items.includes(record.pendingHandle) !== record.pendingSaved) {
      items = await nextStore.set(record.pendingHandle, record.pendingSaved);
    }
    if (version !== sessionVersion) return;
    handles = items; connected = true; connecting = false; busy = false; suspended = document.hidden;
    await render();
    if (!document.hidden) window.scrollTo(0, record.scrollY);
  }
  async function initialize() {
    if (initialized || document.hidden) return;
    initialized = true;
    try {
      let record = null;
      if (configured) {
        try { record = redirectStore().take(); }
        catch (cause) { if (account || cause instanceof SyntaxError || !['SecurityError', 'QuotaExceededError'].includes(cause.name)) throw cause; }
      }
      const version = sessionVersion;
      if (record) {
        account = true; connecting = true; busy = true; reflect();
        const owner = await probe();
        if (version !== sessionVersion) return;
        if (!owner) throw Object.assign(new Error('Deine Shop-Sitzung ist abgelaufen. Bitte melde dich im Kundenkonto an.'), {code:'login_required'});
        if (record.owner && owner !== record.owner) throw new Error('Dein Kundenkonto wurde gewechselt. Bitte öffne die Merkliste erneut.');
        starting = false;
        await finishConnection(record);
        return;
      }
      if (configured) {
        const owner = await probe();
        if (version !== sessionVersion) return;
        account = Boolean(owner);
      }
      starting = false;
      if (account && gallery && configured) return startConnection();
      if (!account) { store = new GuestWishlist(localStorage); handles = store.list(); }
      await render();
    } catch (cause) { connectionFailed(cause); }
    finally { starting = false; reflect(); }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-wishlist-toggle]'); if (!button || button.disabled) return;
    event.preventDefault(); event.stopPropagation();
    const handle = button.dataset.wishlistToggle;
    if (account && !connected) { startConnection(handle); return; }
    let saved;
    const version = sessionVersion;
    try {
      saved = !(account ? handles : store.list()).includes(handle);
      busy = true; reflect();
      const items = account ? await accountStore.set(handle, saved) : store.set(handle, saved);
      if (version !== sessionVersion) return;
      handles = items; busy = false;
      announcer.textContent = saved ? 'Produkt gemerkt.' : 'Produkt entfernt.';
      const index = button.closest('.wishlist__card') ? [...grid.children].indexOf(button.closest('.wishlist__card')) : undefined;
      await render(index);
    } catch (cause) {
      busy = false;
      if (account && cause.code === 'reauthorization_required') return startConnection(handle, {pendingSaved:saved});
      if (account && !connected) connectionFailed(cause);
      else error('Änderung konnte nicht gespeichert werden. Bitte erneut versuchen.');
    } finally { busy = false; reflect(); if (suspended && !document.hidden) foreground(); }
  }, true);
  connect?.addEventListener('click', () => startConnection(null, {silent:false}));
  logout?.addEventListener('click', () => {
    clearRedirect();
    const url = auth.logoutUrl(); signal();
    if (url) location.assign(url);
    else render();
  });
  retry?.addEventListener('click', refresh);
  const invalidateFromOtherTab = () => {
    clearRedirect();
    if (account) { auth.clear(); connecting = false; starting = false; error('Deine Anmeldung wurde geändert. Bitte lade deine Kontomerkliste erneut.'); }
  };
  channel?.addEventListener('message', event => { if (event.data === 'invalidate') invalidateFromOtherTab(); });
  window.addEventListener('storage', event => {
    if (event.key === signalKey || event.key === null) invalidateFromOtherTab();
    if (!account && (event.key === null || event.key.startsWith(PREFIX))) refresh();
  });
  document.addEventListener('shopify:section:load', reflect);
  const wishlistControls = '[data-wishlist-toggle], [data-wishlist-header], [data-wishlist-count]';
  new MutationObserver(records => {
    const needsRefresh = records.some(record => {
      const target = record.target;
      if (target?.matches?.('[data-wishlist-count]') &&
          (target.textContent !== String(visibleHandles().length) || target.hidden !== (visibleHandles().length === 0))) return true;
      if (target?.matches?.('[data-wishlist-header]') &&
          target.getAttribute('aria-label') !== `Merkliste: ${visibleHandles().length} Produkte`) return true;
      return [...record.addedNodes].some(node => node.nodeType === 1 &&
        (node.matches?.(wishlistControls) || node.querySelector?.(wishlistControls)));
    });
    if (needsRefresh) reflect();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-label'] });
  window.addEventListener('pagehide', () => {
    if (!leaving) clearRedirect();
    leaving = true; pageController.abort();
    auth.clear(); revision++; handles = []; grid?.replaceChildren(); reflect(); channel?.close();
  });
  async function foreground() {
    if (!initialized) return initialize();
    if (leaving || document.hidden || starting || connecting || checking || busy || !configured) return;
    checking = true; reflect();
    const version = sessionVersion;
    try {
      const previousOwner = observedOwner;
      const owner = await probe();
      if (version !== sessionVersion) return;
      if (owner !== previousOwner) {
        auth.clear(); account = Boolean(owner); suspended = false;
        if (account && gallery) { checking = false; return startConnection(); }
        if (!account) { store ||= new GuestWishlist(localStorage); handles = store.list(); }
      } else if (connected) {
        await auth.ensureSession();
        const items = await accountStore.load();
        if (version !== sessionVersion || document.hidden) return;
        handles = items;
      }
      suspended = false; checking = false; await render();
    } catch (cause) {
      if (leaving) return;
      checking = false;
      if (cause.code === 'reauthorization_required' && gallery) { suspended = false; return startConnection(); }
      connectionFailed(cause);
    } finally { checking = false; reflect(); }
  }
  document.addEventListener('visibilitychange', () => {
    if (document.hidden && account) { suspended = true; revision++; grid?.replaceChildren(); reflect(); }
    else if (!document.hidden) foreground();
  });
  setInterval(() => { if (!document.hidden && connected) foreground(); }, 15000);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]'); if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin === wishlistConfig.accountOrigin || /\/account\/logout(?:\/|$)/.test(url.pathname)) {
      clearRedirect(); auth.clear(); signal();
    }
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
  reflect();
  initialize();
}
